import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import Select from 'react-select'
import { Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"

const columns = [
    {
        label: 'ID',
        field: 'id',
        sort: 'asc'
    },
    {
        label: 'Articulo',
        field: 'articulo_descripcion',
        sort: 'asc'
    },
    {
        label: 'Asignado a',
        field: 'departamento_Nombre',
        sort: 'asc'
    },
    {
        label: 'Estado',
        field: 'string_estado',
        sort: 'asc'
    },
    {
        label: 'Fecha',
        field: 'fecha_formato',
        sort: 'asc'
    },
    {
        label: 'Cantidad',
        field: 'cantidad',
        sort: 'asc'
    },
    {
        label: 'Acciones',
        field: 'handle',
        sort: 'asc'
    }
];

export default class ensamblePorDepartamento extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);

        this.state = {
            tabla: { columns: columns, rows: [] },
            modalAbierto: false,
            mostrarSpinner: true
        }
    }

    componentDidMount() {
        this.cargarListado();
    }

    cargarListado = () => {
        this.setState({ mostrarSpinner: true });
        let id = this.apiRest.getLS('du').colaborador.id;
        if (this.apiRest.getRol()) {
            this.apiRest.get('/ensambleListaAdmin').then(res => {
                if(res.exitoso){
                    this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(res.data) });
                }
            })
        } else {
            this.apiRest.get("/ensamble_list/" + id).then(response => {
                if (response.exitoso) {
                    //console.log(response.data);
                    this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(response.data) });
                }
            }).catch(error => {
                toastr.error(error);
            });
        }
    }

    agregarAccionesRegistro = rows => {
        rows.forEach(registro => registro.handle = this.botonesListado(registro));
        return { columns, rows: rows };
    };

    botonesListado = registro => [
        <MDBBtn className="waves-effect" size="sm" color="primary" title="Ensamblar" onClick={() => this.props.history.replace({ pathname: '/ensambleDepartamento', registro: registro })}>
            <MDBIcon icon="fas fa-cog" />
        </MDBBtn>
    ];

    render() {
        const {

        } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Ensamble" breadcrumbItem="Lista de Activos para Ensamble" />
                        <Row>
                            <Col className="col-12">
                                <Card>

                                    <CardBody>
                                        {
                                            this.state.mostrarSpinner &&
                                            <Row>
                                                <Col style={{ display: "flex", justifyContent: "center" }}>
                                                    <Spinner className="m-1" color="primary" />
                                                </Col>
                                            </Row>
                                        }
                                        <div className="table-responsive">
                                            <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={this.state.tabla} />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}